import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { CartProvider } from "./Modules/Contexts/CartContext";
import { ServerStatusProvider } from "./Modules/Contexts/ServerStatusContext";

import "./Css/Reset.css";
import "./Css/Global.css";
import "antd/dist/reset.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ServerStatusProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </ServerStatusProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
